export default __webpack_public_path__ + "static/media/Forms_128x128.0ece9c65.webp";